angular
  .module('caferealtor.listing.network.publish', ['ngRoute'])

  .config([
    '$routeProvider',
    function ($routeProvider) {
      $routeProvider.when('/listing/publish', {
        template: require('./publish.html'),
        controller: 'PublishCtrl',
      });
    },
  ])

  .controller('PublishCtrl', [
    '$scope',
    '$resource',
    function ($scope, $resource) {
      const Listing = $resource('/listing/network/eligible');

      Listing.get().$promise.then(data => {
        $scope.listings = data.listings;
        $scope.dataLoaded = true;
      });
    },
  ]);
